import { instance as axios } from './axios_common';

export const getCategories = async () => {
	return axios.get('categories/', {
		headers: {
			Authorization: `Bearer ${localStorage.getItem('token')}`,
		},
	});
};
